export const VERSION = "v3.1.62";
export const EXT_TITLE = "Webint Center";